import { createSelector } from '@reduxjs/toolkit';

import type { PreviewFileType } from '@pages/organizer/Cloud/store/upload-store/upload-types';
import type { RootState } from '@store/store';

const progressSelector = (state: RootState) => state.cloudUpload.progress;
export const uploadCountsSelector = (state: RootState) => state.cloudUpload.uploadCounts;
export const progressState = createSelector([progressSelector], (progress) => progress);
const visibleSelector = (state: RootState) => state.cloudUpload.visible_popup;
export const visiblePopupState = createSelector([visibleSelector], (visible) => visible);

const expandSelector = (state: RootState) => state.cloudUpload.expand_popup;
export const expandVisiblePopup = createSelector([expandSelector], (expand) => expand);

const selectUploads = (state: RootState) => state.cloudUpload.uploads;

export const selectSortedUploads = createSelector([selectUploads], (uploads): PreviewFileType[] => {
  return Object.values(uploads).sort((a, b) => {
    return new Date(b.create_at).getTime() - new Date(a.create_at).getTime();
  });
});
